// Import shared
require('./shared')

// Import widgets
require('../../widgets/search/main')

require('../../../js/core/widget/widget-api')

require('../../../js/tracking/newrelic')
